module.exports = __webpack_public_path__ + "img/dingding.85e19988.png";